import axios from 'axios';

export enum KeyPhraseType {
    Profane = 0, // Profane keywords (will show an error and not allow posts)
    Rejected = 10, // Warning keywords (will show a warning but allow posts)
}

export interface KeyPhrase {
    keyPhraseText: string;
    sourceBegin: number;
    sourceEnd: number;
    keyPhraseType: KeyPhraseType;
}

export const getKeyPhrases = async (tenantId: number | undefined, sourceText: string): Promise<KeyPhrase[]> => {
    const { data } = await axios.post<KeyPhrase[]>(`/api/tenants/${tenantId}/key-phrases/find`, { sourceText });

    return data;
};
